import React, {useCallback, useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {ComponentNoData} from "../../../components/ComponentLoader";
import SelectedMoveActions, {SelectedActionButton, SelectedActionButtonRef} from "./SelectedMoveActions";
import DynamicSelectedItem from "./DynamicSelectedItem";
import CustomIcon from "../../../components/CustomIcon";
import DropdownMenu, {DropdownItem, DropdownItemGroup} from '@atlaskit/dropdown-menu';
import {cloneDeep, debounce, isEmpty} from "lodash";
import {TAB_NOT_ADDED} from "../constants";
import CustomButton from "../../../components/CustomButton";
import {SortableCard} from "../../../components/SortableCard";
import {CustomSpinner} from "../../../components/CustomSpinner";
import {bulkUpdateItems} from "../../../redux/slices/dynamicUiSlice";
import useDidMount from "../../../hooks/useDidMount";
import styles from './PreviewSelected.module.css';
import CustomMessage from "../../../components/CustomMessage";
import {
  getFilteredDynamicData,
  getUiBreadCrumbFormat,
  hasTheGivenPlatform, isMobilePlatform, isWebPlatform
} from "../dynamicUiFunctions";

const PreviewSelected = ({onClose}) => {

  const [selectedItems, setSelectedItems] = useState([]);
  const [unSelectedItems, setUnSelectedItems] = useState([]);
  const [displayMenu, setDisplayMenu] = useState(false);
  const [coverView, setCoverView] = useState(false);
  const [mobileView, setMobileView] = useState(true);
  const isPlatformMobile = useSelector((state) => state.dynamicUi.isPlatformMobile);

  const selectedPage = useSelector((state) => (state.dynamicUi.pages.selectedPage));



  // const {loading, data, init, error} = useSelector((state) => state.dynamicUi.selected);
  const {
    data = [],
  } = useSelector((state) => state.dynamicUi.selected[selectedPage]) ?? {};

  // const {data} = useSelector((state) => state.dynamicUi.selected);




  const {data: items} = useSelector((state) => state.dynamicUi.items);
  const {error, loading, flag} = useSelector((state) => state.dynamicUi.bulkUpdate);
  const dispatch = useDispatch();

  // const platformWiseSelectedData = getSelectedDataByPlatform(data, mobileView ? PLATFORM_MOBILE : PLATFORM_WEB);
  // const uu = useMemo(getSelectedDataByPlatform(data, mobileView ? PLATFORM_MOBILE : PLATFORM_WEB), [data, platformWiseSelectedData]);

  useEffect(() => {

    setUnSelectedItems(cloneDeep(getFilteredDynamicData(items, TAB_NOT_ADDED, selectedItems, mobileView)));
  }, [mobileView]);

  useEffect(() => {
    setSelectedItems(cloneDeep(data));
    setUnSelectedItems(cloneDeep(getFilteredDynamicData(items, TAB_NOT_ADDED, data, isPlatformMobile)));
    setMobileView(isPlatformMobile)
  }, [isPlatformMobile]);

  const onMoveUpDown = (pos, up = true) => {
    const tempSelectedItems = cloneDeep(selectedItems);


    const arraysToCheck = up ? tempSelectedItems.slice(0, pos).reverse() : tempSelectedItems.slice(pos + 1, tempSelectedItems.length);
    let counter = 1;
    for (let i = 0; i < arraysToCheck.length; i++) {
      if ((mobileView && isMobilePlatform(arraysToCheck[i].section.platform, true))
        || (!mobileView && isWebPlatform(arraysToCheck[i].section.platform, true))) {
        break;
      }
      counter++;
    }
    if (counter <= arraysToCheck.length) {
      const moveTo = up ? pos - counter : pos + counter;
      const dragCard = tempSelectedItems[pos];

      tempSelectedItems.splice(pos, 1);
      tempSelectedItems.splice(moveTo, 0, dragCard);

      // tempSelectedItems[pos] = selectedItems[moveTo];
      // tempSelectedItems[moveTo] = selectedItems[pos];
      setSelectedItems(tempSelectedItems);
    }



    // const moveTo = up ? pos - 1 : pos + 1;

    // tempSelectedItems[pos] = selectedItems[moveTo];
    // tempSelectedItems[moveTo] = selectedItems[pos];
    // setSelectedItems(tempSelectedItems);
  };

  const reset = (pos, up = true) => {
    setSelectedItems(cloneDeep(data));
    setUnSelectedItems(cloneDeep(getFilteredDynamicData(items, TAB_NOT_ADDED, data, mobileView)));
  };

  const remove = (item, pos) => {
    //remove from selected list
    const tempArray = cloneDeep(selectedItems);
    tempArray.splice(pos, 1);
    setSelectedItems(tempArray);

    //add to unselected
    setUnSelectedItems([...unSelectedItems, {...item.section}]);
  };

  const addItems = (item, pos) => {
    //remove from unselected list
    const tempArray = cloneDeep(unSelectedItems);
    tempArray.splice(pos, 1);
    setUnSelectedItems(tempArray);

    //add to selected
    setSelectedItems([...selectedItems, {id: Date.now().toString(), section: item}]);
  };

  const moveCard = useCallback((dragIndex, hoverIndex) => {
    const tempArray = cloneDeep(selectedItems);
    const dragCard = tempArray[dragIndex];
    tempArray.splice(dragIndex, 1);
    tempArray.splice(hoverIndex, 0, dragCard);

    setSelectedItems(tempArray);

  }, [selectedItems]);

  const saveData = () => {
    dispatch(bulkUpdateItems(selectedItems));
  };

  useDidMount(() => {

    onClose();

  }, [flag]);

  const isChangeMade = selectedItems.length !== data.length ||
    selectedItems.some((item, index) => item.id !== data[index].id);

  // noinspection JSCheckFunctionSignatures
  const debouncedToggleView = useCallback(
    debounce(() => {
      //   dispatch(togglePlatform());
      setMobileView(!mobileView);
    }, 200),
    [dispatch, mobileView]
  );


  return (
    <div
      className={`fixed -left-2 bottom-0 w-full h-full bg-secondary-100 z-40 preview ${mobileView ? 'mobile': 'web'}`}>

      {loading ?
        <div className="flex items-center justify-center h-full text flex-col">
          <CustomSpinner/>
          <div className="mt-5">Please wait... Saving contents.</div>
        </div> :
        <div className="flex flex-col items-center justify-between w-full h-full">
          <div className="flex flex-col flex-grow w-full" style={{maxHeight: "calc(100vh - 4.8rem)"}}>
            <div className="flex w-full justify-center relative">
              <CustomIcon icon="close" className="text-rand-100 absolute right-7 top-5 cursor-pointer"
                          size="3xl" onClick={onClose}/>

              <SelectedMoveActions displayMenu={displayMenu} setDisplayMenu={setDisplayMenu} previewButton={false}
                                   toggleUiView={debouncedToggleView} mobileView={mobileView}
                                   refreshButton={false} className="m-4">
                <SelectedActionButton onClick={reset} tooltip="Reset changes"
                                      icon="restart_alt"/>
                <SelectedActionButton onClick={() => setCoverView(!coverView)} tooltip={coverView ? 'Hide device frame' : 'Show device frame'}
                                      icon={coverView ? 'web_asset' : 'web_asset_off'}/>
                <DropdownMenu
                  trigger={({triggerRef, isSelected, testId, ...props}) => (
                    <SelectedActionButtonRef onClick={reset} tooltip="Add Elements to the UI"
                                             ref={triggerRef} {...props}
                                             icon="add"/>
                  )}
                >
                  <DropdownItemGroup className="h-1/3">
                    {unSelectedItems.map((item, i) =>
                      <DropdownItem key={`unselected-menu-${item.id}`}
                                    onClick={() => addItems(item, i)}>{getUiBreadCrumbFormat(item)}</DropdownItem>
                    )}
                  </DropdownItemGroup>
                </DropdownMenu>

              </SelectedMoveActions>
            </div>
            <div className="overflow-auto w-full flex justify-center max-w-[1364px] mx-auto">
              {/*<div className={`${coverView ? styles.coverViewWrapper : styles.normalViewWrapper} zoom-out`}>*/}
              <div
                className={`${mobileView ? styles.mobileViewWrapper : styles.webViewWrapper} ${coverView ? styles.coverViewWrapper : styles.normalViewWrapper} zoom-out`}>
                <div className="vertical bg-background border border-rand-300 shadow-lg scrollbar"
                >
                  <div className="bg-background pb-3">
                    {!selectedItems?.length ?
                      <ComponentNoData msg="No data" className="image-aspect-ratio mt-2"/> :

                      selectedItems.map((item, pos) =>

                          <SortableCard key={`previewed-selected-item-${item.id}`}
                                        index={pos} id={`previewed-selected-item-${item.id}`} text={
                            <DynamicSelectedItem item={item} key={`previewed-selected-item-${item.id}`}
                                                 mobile={mobileView}
                                                 hidden={mobileView && isWebPlatform(item.section.platform) || !mobileView && isMobilePlatform(item.section.platform)}
                                                 isFirst={pos === 0 ||
                                                   (!hasTheGivenPlatform(mobileView, selectedItems.slice(0, pos)))}
                              // (!mobileView && !selectedItems.slice(0, pos).some((it)=>it.section.platform === PLATFORM_WEB || it.section.platform === PLATFORM_BOTH))}
                                                 onMoveUp={() => onMoveUpDown(pos)}
                                                 onDelete={() => remove(item, pos)}
                                                 onMoveDown={() => onMoveUpDown(pos, false)}
                                                 isLast={pos === selectedItems.length - 1 || (!hasTheGivenPlatform(mobileView, selectedItems.slice(pos + 1, selectedItems.length)))}
                                                 showActions={displayMenu}
                            />
                          } moveCard={moveCard}/>
                      )
                    }
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center w-full p-2 bg-white border-t">
            <div className="flex items-center justify-between w-full max-w-screen-xl">
              <CustomMessage message={mobileView ? "Warning!!! Saving changes will have immediate effect in the Mobile App." : "Warning!!! Saving changes will have immediate effect in the Web App."}
                             hasBackground={false}/>
              <CustomButton className="px-8" disabled={!selectedItems?.length || !isChangeMade}
                            onClick={saveData}>Save</CustomButton>
            </div>
          </div>

        </div>}
    </div>
  );
};

export default PreviewSelected;

